module.exports = __webpack_public_path__ + "img/icon-activity-meeting.40b284da.svg";